const jaJPJson = {
  common: {
    add: "追加",
    edit: "編集",
    view: "表示",
    update: "更新",
    apply: "反映",
    reset: "リセット",
    delete: "削除",
    search: "検索",
    menu: "メニュー",
    actions: "操作",
    noDataAvailable: "利用可能なデータがありません",
    loadingText: "データを読み込んでいます。お待ちください。",
    cancel: "キャンセル",
    select: "選択",
    close: "閉じる",
    save: "保存",
    yes: 'はい',
    no: 'いいえ',
    expand: "展開",
    collapse: "折りたたみ",
    downloadPDF: "PDFダウンロード",
    downloadCSV: "CSVダウンロード",
    downloadExcel: "Excelダウンロード",
    tips: {
      downloadFailed: "ダウンロードに失敗しました。"
    },
    tip: {
      addSuccess: "追加が完了しました。",
      addFailed: "追加ができませんでした。",
      updateSuccess: "更新が完了しました。",
      updateFailed: "更新ができませんでした。",
      revertSuccess: "元の状態に戻すことに成功しました。",
      revertFailed: "元の状態に戻せませんでした。",
      deleteSuccess: "削除が完了しました。",
      deleteFailed: "削除ができませんでした。",
      deletion: "削除理由を入力してください。",
      limit_2000: "最大文字数2000文字を超えています。",
      selectOneItem: "1つの項目を選択してください。",
      selectTarget: "最初に対象を選択してください。",
      jsonError: 'JSON形式が正しくありません。正しいJSON形式で入力してください。'
    },
    jsonLabel: 'JSON',
    next: "次へ",
    disable: "使用停止にする",
    enable: "使用可能にする",
    editable: "編集可能",
    readOnly: "読み取り専用",
    status: "ステータス",
    type: "区分",
    mandatory: "必須",
    selectAll: "すべて選択",
    pleaseSelect: "Please select",
  },
  validation: {
    isRequired: "必須",
    regexErrorTip: 'Please enter a valid format',
    numberTooSmallTip: 'The value must be at least {{number}}',
    numberTooBigTip: 'The value must be at most {{number}}',
    numberIntegerOnly: 'Integer only',
    numberMaxDecimalPlaces: "No more than {{number}} decimal places",
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}'
  },
  menu: {
    planTrack: "計画&追跡",
    processManager: "プロセス管理",
    taskManager: "タスク管理",
    templateManager: "テンプレート管理",
    templateAutoLauncher: "テンプレートオートロンチャー",
    addDefaultProcess: "Add Default Process",
    viewDefaultProcess: "View Default Process"
  },
  planTrack: {
    processes: "プロセス",
    plans: "計画",
    reports: "レポート",
    tasks: "タスク",
    report: {
      module: 'モジュール',
      reportType: 'レポートタイプ',
      reportName: 'レポート名',
    }
  },
  grid: {
    process: "親プロセス",
    processInstanceId: "プロセスインスタンスID",
    parentProcess: "食品・サプリメント",
    taskName: "タスク名",
    objectId: "オブジェクト ID",
    parentObjectId: "親オブジェクトID",
    object: "オブジェクト",
    processTypeName: "プロセス区分",
    processStatus: "プロセスステータス",
    domain: "領域",
    module: "モジュール",
    taskStatus: "タスクステータス",
    showNotStarted: "未開始",
    showInProgress: "進行中",
    showCompleted: "完了済",
    downloadPDF: "PDFをダウンロード",
  },
  process: {
    process: 'プロセス',
    processName: 'プロセス名',
    processOwner: 'プロセス所有者',
    processInitiator: 'プロセス開始者',
    processStartDate: 'プロセス開始日',
    task: 'タスク',
    milestones: 'マイルストーン',
    // notStarted: '未開始',
    // completed: '完了',
    // inProgress: '進行中',
    plannedStartDate: '計画開始日',
    plannedDuration: '計画期間（日数）',
    plannedEndDate: '計画終了日',
    actualStartDate: '実際の開始日',
    actualDuration: '実際の期間（日数）',
    actualEndDate: '実際の終了日',
    projectedStartDate: '予測開始日',
    projectedEndDate: '予測終了日',
    milestoneName: 'マイルストーン名',
    milestoneDate: 'マイルストーン日',
    milestone: 'マイルストーン',
    processID: "プロセスID",
    associate: {
      associate: "関連付け",
      pageHeader: "プロセスの関連付け",
      selectProcess: "プロセスを選択",
      processInitiation: "プロセスの開始",
      initiate: "開始",
      initiator: "開始者",
      processInitiators: "プロセス開始者",
      emptyProcessTip: "少なくとも1つのプロセスを選択してください。",
      associateSuccess: "プロセスが正常に関連付けられました。",
      associateFail: "プロセスの関連付けに失敗しました。",
      initiateSuccess: "プロセスが正常に開始されました。",
      initiateFail: "プロセスの開始に失敗しました。",
      initiateWarning: "プロセスを開始するには、赤で強調表示された必須フィールドに入力してください。",
      description: "説明",
      preview: "プレビュー"
    },
    ownerAndInitiator: "プロセスオーナーとプロセス開始者",
    comment: 'コメント',
    attachment: '添付ファイル',
    addtask: 'タスクを追加',
    deletetask: 'タスクを削除',
    parallelMultiInstance: "並列マルチインスタンスタスク",
    sequentialMultiInstance: "順次マルチインスタンスタスク",
    deleteMultiTaskComfirm: 'このタスクを削除してもよろしいですか？',
    milestoneExtension: {
      title: "タイムライン調整",
      successTip: "保存に成功しました。",
      errorTip: "保存に失敗しました。"
    },
    noMilestoneTip: "There are no milestones for this process.",
    autoTemplate: {
      defaultTemplate: "デフォルトテンプレート",
      module: "モジュール",
      recordType: "レコードタイプ",
      title: "デフォルトテンプレート設定",
      listTitle: "テンプレート自動起動",
      templateRule: "テンプレートルール",
      templateRuleTip: "同じレコードタイプの異なるルールで定義された識別子は相互に排他的である必要があります。そうでない場合、システムは設定の順序に基づいて最初に一致するテンプレートを起動します。",
      associateTemplate: "テンプレート関連付け",
      templateRequired: "テンプレート関連付けが必要です",
      autoInitiation: "自動開始",
      whenIdentifiers: "識別子の場合",
      selectIdentifiers: "識別子選択",
      editIdentifiers: "Edit Identifiers",
      addRule: "ルール追加",
      saveRuleSuccess: "デフォルトテンプレートが正常に保存されました",
      noIdentifiers: "識別子なし",
      addIdentifiersTip: "The rules have been added successfully",
      autoInitiationDisabledTooltip: "Please fill in the selected template's first task's mandatory fields"
    },
    panel: {
      selectElementTip: "Please select an element",
      selectResultTypePH: "Select the Result Type",
      completeSourceNodeTip: "Please complete the source node",
      module: "Module",
      task: "Task",
      saveProperties: "Save Properties",
      taskSaveSuccess: "Task saved successfully.",
      conditionSaveSuccess: "Condition saved successfully.",
      resultType: "Result Type",
      outboundCondition: "Outbound Condition",
      atLeastOneTip: "At least one condition is required",
      inboundBasicConditions: "Inbound Basic Conditions",
      basicConditions: "Basic Conditions",
      conditionIsRequired : "Condition is required",
      resultTypeIsRequired : "Result Type is required",
      saveCondition: "Save Condition",
      missingPropertyTip: "The preceding User Task has incomplete required properties. Please complete all properties before configuring the flow.",
    }
  },
  filter: {
    apply: "適用",
    and: "終了",
    clear: "解除",
    searchIntro: "絞り込む項目にチェックを入れてください",
    selected: "選択中",
    more: "フィルター項目を追加",
    identifiers: "フィルター項目",
    before: "この日付以前",
    after: "この日付以降",
    beforeThanPlaceholder: "この日付以前を選択してください",
    afterThanPlaceholder: "この日付以降を選択してください",
    fromDatePlaceholder: "開始日を選択",
    toDatePlaceholder: "終了日を選択",
    between: "日付範囲",
    total: 'すべての',
    reset: 'リセット',
    filterItems: {
      label: "フィルター項目",
      totalLabel: "すべてのフィルター項目",
      searchPlaceholder: "フィルター項目を検索",
    },
    placeholder: {
      modules: "モジュール",
      processes: "プロセス",
      processStatuses: "プロセスのステータス",
      taskStatuses: "タスクの状態",
    },
    selectedCount: "{{count}}個選択中"
  },
  myTask: {
    myTasks: 'タスク',
    performTask: 'タスクを実行',
    showMoreTasks: 'Show more',
    showLessTasks: 'Show less',
    noStartedTasks: '開始待ちのタスクはありません。',
    noInProgressTasks: '進行中のタスクはありません。',
    noCompletedTasks: '完了したタスクはまだありません。',
    notStarted: '未開始',
    inProgress: '進行中',
    completed: '完了済',
    planned: "Planned",
    filter: {
      modules: 'モジュール',
      filters: 'フィルター',
      apply: '適用',
      clear: '解除',
      enterSearch: '検索キーワードを入力してください',
      status: 'ステータス',
      from: '開始日',
      to: '終了日',
      all: 'すべて'
    },
    bulkActions: {
      label: '一括操作',
      performTasks: '一括タスク実行',
      performDisabledTip: '同じモジュール内の同じ種類のタスクを少なくとも2つ選択し、一括完了を可能にしてください。',
      limitsTip: "Due to performance limits, you can only complete up to 100 records in a single batch."
    }
  },
  processManager: {
    template: "テンプレート",
    templates: "テンプレート",
    id: "プロセステンプレートID",
    processTemplateName: "プロセステンプレート名",
    processType: "プロセスタイプ",
    processTemplateDescription: "プロセステンプレート説明",
    processTemplateVersion: "Process BPMN Version",
    taskMandatoryFieldCheck: "Check All Mandatory Fields",
    taskMandatoryFieldCheckTips: "Enable this option to enforce mandatory field validation across all tasks within the process before submission. If disabled, mandatory field checks will only apply to the first task",
    editDetails: "テンプレート編集",
    addDetails: "テンプレート追加",
    cloneTemplate: "Clone Template",
    editBPMN: "BPMN編集",
    domains: "プロセステンプレートドメイン",
    addBPMN: "BPMN追加",
    taskManagerTitle: "タスクマネージャー",
    cloneConfirmMessage: "Do you want to clone the selected template?",
    cloneSuccess: "Template has been cloned successfully.",
    cloneError: "Template cloning failed.",
    taskManager: {
      taskProperties: "タスクプロパティ",
      taskId: "タスクID",
      taskName: "タスク名",
      displayName: "表示名",
      lifecycleIntegration: "Lifecycle Integration",
      lifecycleConcept: "Lifecycle Concept",
      moduleName: "モジュール名",
      domainName: "ドメイン名",
      configureTask: "Configure Task",
      order: "順序",
      propertyName: "プロパティ名",
      property: "プロパティ",
      configurability: "設定可能性",
      fixed: "固定",
      configurable: "設定可能",
      configurabilityInfo: "固定とは、プロセス実行中にフィールド値を変更できず、設定可能とは実行時に値を上書きできることを意味します。",
      detailsPage: {
        sectionTitle: "プロセス詳細ページ設定",
        visibility: "可視性",
        visibilityInfo: "'可視性'フィールドは、このフィールドがプロセス詳細ページに表示されるかどうかを決定します。"
      }
    },
    templateManager: {
      version: "Version",
      modifiedBy: "Modified By",
      modifiedDate: "Modified Date",
      comment: "Comment",
      viewHistory: "View History",
      addComment: "Add Comment",
      commentPlaceholder: "Please enter your comment",
      emailNotification: "Email Notification",
      enableAllTaskEmailNotification: "Enable email notification for all tasks",
      ccRecipients: "Default CC recipients",
      ccRecipientsTips: "PM Roles that will be CC'd on task emails.",
      addtionalCcRecipients: "Custom CC recipients",
      addtionalCcRecipientsTips: "Users / Groups / Roles that will be CC'd on task emails.",
      emailNotificationConfiguration: "Email Notification Configuration",
      basicInformation: "Basic Information",
    },
  },
};

export default jaJPJson;
